import request from '@/utils/request'
// 投诉列表
export function getComplaintList (params) {
  return request({
    url: '/complaint/application/getList',
    method: 'get',
    params: params
  })
}
//投诉单查看
export function getComplaintDetail (params) {
  return request({
    url: '/complaint/application/detail',
    method: 'get',
    params: params
  })
}
// 提交申述
export function submitApplication (data) {
  return request({
    url: '/complaint/application/submit',
    method: 'post',
    data: data
  })
}


// WEBPACK FOOTER //
// ./src/api/complaint.js